import { create } from 'zustand';
import { jobsApi } from '../services/api';
import { ResearchJob } from '../types';

/**
 * Lightweight cache for the dashboard job list so navigating back to the
 * dashboard renders instantly (from cache) while a refresh runs in the
 * background — instead of a spinner + full refetch on every mount.
 *
 * The list payload is the slim ResearchJobListItem shape from GET /jobs/
 * (no memo MD/HTML); the full memo is fetched per-job on JobDetail.
 */
interface JobsState {
  jobs: ResearchJob[];
  lastFetched: number | null;
  isFetching: boolean;
  /** Fetch the most recent jobs and update the cache. */
  fetchJobs: (limit?: number) => Promise<void>;
}

export const useJobsStore = create<JobsState>((set, get) => ({
  jobs: [],
  lastFetched: null,
  isFetching: false,
  fetchJobs: async (limit = 10) => {
    if (get().isFetching) return;
    set({ isFetching: true });
    try {
      const { data } = await jobsApi.getJobs(0, limit);
      set({ jobs: data, lastFetched: Date.now(), isFetching: false });
    } catch {
      set({ isFetching: false });
    }
  },
}));
